var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagzlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 694.629,
    height: 80.734,
    viewBox: "0 0 694.629 80.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41741",
    "data-name": "Group 41741",
    transform: "translate(0.029 -0.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41738",
    "data-name": "Group 41738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78866",
    "data-name": "Path 78866",
    d: "M146.4.3H74.5s-6.3,1.3-9.2,7L36.6,74.6s-2.7,7.9,10.3,5.3c0,0,5.7-.5,9.4-10.1L67.9,43.7s5.1-7.8,12.5-3.6c0,0,2.9,2.1.3,7.5,0,0-8.2,19.5-9.6,23.2,0,0-3.3,7.2,11.1,5.1,0,0,5.4-.6,7.8-7.4l10.6-24.1s5.5-8.8,13.6-4c0,0,3.5,2.2.1,8.2L103.2,74.2s-3.4,7.3,8.4,5.9c0,0,7.6,1.6,11.3-9.5L150.7,6.3C150.6,6.3,151.4,1.2,146.4.3Z",
    fill: "#98c93c",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78867",
    "data-name": "Path 78867",
    d: "M4.5.3H76.3s6.3,1.3,9.2,7l28.8,67.4s2.8,7.9-10.3,5.3c0,0-5.7-.5-9.4-10.1L83,43.6S77.9,35.8,70.5,40c0,0-2.9,2.1-.3,7.5,0,0,8.2,19.5,9.6,23.2,0,0,3.3,7.2-11.1,5.1,0,0-5.4-.6-7.8-7.4L50.4,44.3s-5.5-8.8-13.6-4c0,0-3.5,2.2-.1,8.2L47.8,74.1s3.4,7.3-8.4,5.9c0,0-7.6,1.6-11.3-9.5L.3,6.3S-.6,1.2,4.5.3Z",
    fill: "#3499fe",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41740",
    "data-name": "Group 41740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41739",
    "data-name": "Group 41739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78868",
    "data-name": "Path 78868",
    d: "M190.2,3.1l18.9,59.1L229,3.1h23.5V78.8H237.1V21.9L217.3,78.8H200.7L182,21.9V78.8H166.6V3.1Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78869",
    "data-name": "Path 78869",
    d: "M259,78.8,290.3,3.1h18.6l31.3,75.7H321.3L314,61.3H285.2l-7.3,17.5Zm40.6-57.5L288.8,47.8h21.6Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78870",
    "data-name": "Path 78870",
    d: "M370.9,33.8h37.2v45H374.3a58.263,58.263,0,0,1-14-1.3,26.57,26.57,0,0,1-9.4-4.6c-8-6.1-11.9-16.7-11.9-31.7,0-9.8,1.9-18,5.7-24.5A24.639,24.639,0,0,1,356.2,6.3Q363.4,3,375.1,3h33.1V16.5H377c-6.7,0-11.6,1.5-14.7,4.4-3.6,3.5-5.4,9.7-5.4,18.7a53.093,53.093,0,0,0,1.4,12.5c.9,3.7,2.2,6.5,3.9,8.3a13.052,13.052,0,0,0,6,3.7,31.146,31.146,0,0,0,9.4,1.2H392v-18H370.9Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78871",
    "data-name": "Path 78871",
    d: "M464.4,16.5H416.6V3.1h65.9V17L436.4,65.3h46.1V78.8H416.6V65.7Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78872",
    "data-name": "Path 78872",
    d: "M509.6,16.5H485.5V3.1h65.3V16.6H525.7V78.9H509.6Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78873",
    "data-name": "Path 78873",
    d: "M614.2,3.1V16.6h-21c-5.5,0-9.5.4-12,1.1a11.9,11.9,0,0,0-6.2,4.4,13.745,13.745,0,0,0-2.3,4.5,48.831,48.831,0,0,0-1.1,7.8h42.6V47.9H571.6c.6,6.5,2.5,11.1,5.7,13.6,3.3,2.6,8.8,3.8,16.6,3.8h20.3V78.8h-21a93.921,93.921,0,0,1-15-1.1,26.153,26.153,0,0,1-16.3-8.9c-5.7-7-8.6-16.4-8.6-28.3,0-13.2,4-23.5,12.2-30.8a23.919,23.919,0,0,1,8.9-5.2A43.172,43.172,0,0,1,587.1,3h27.1Z",
    fill: "#98c93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78874",
    "data-name": "Path 78874",
    d: "M641.3,50V78.8H625.2V3.1h37c10.6,0,18,1.4,22.3,4.1a18.306,18.306,0,0,1,6.6,7.2,20.6,20.6,0,0,1,2.4,9.8c0,7.2-1.8,12.8-5.5,16.6a21.284,21.284,0,0,1-9,5.4,21.888,21.888,0,0,1,6.7,3.3,16.025,16.025,0,0,1,4.1,5.2,24.067,24.067,0,0,1,2,5.2,60,60,0,0,1,1,7.5,53.7,53.7,0,0,0,1.8,11.4H676.5c-.6-1.8-1.1-5.4-1.7-10.8a31.815,31.815,0,0,0-2.4-10.2,12.773,12.773,0,0,0-5.3-5.5c-2.9-1.6-7.2-2.4-12.8-2.3h-13Zm0-13.5H664c3.8,0,6.5-.6,8-1.7,2.4-1.7,3.6-4.6,3.6-8.8,0-4.6-1.8-7.6-5.4-8.9a21.831,21.831,0,0,0-6.2-.7H641.4V36.5Z",
    fill: "#98c93c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagzlogo);
export default __webpack_public_path__ + "static/media/magzlogo__.81fc7d157bdb9d69e4122999e9c71fe9.svg";
export { ForwardRef as ReactComponent };